import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import { SuccessIcon } from '@eposnow/ui-core';
import FeedbackBanner from '../../../components/feedback/FeedbackBanner';
import FeedbackDialog from '../../../components/feedback/FeedbackDialog';
import ResultFeedbackDialog from '../../../components/feedback/ResultFeedbackDialog';

interface FeedbackSectionProps {
    text: string;
}



const FeedbackSection = ( {text}: FeedbackSectionProps ) => {
  const { t } = useTranslation();
  const [bannerOpen, setBannerOpen] = useState(true);
  const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);
  const [feedbackSuccessOpen, setFeedbackSuccessOpen] = useState(false);

  return (
    <>
      {bannerOpen && (
        <FeedbackBanner
          text={text}
          leftButtonText={t('actions.gotIt')}
          rightButtonText={t('actions.feedback')}
          iconElement={<FeedbackOutlinedIcon sx={{ paddingRight: '5px' }} />}
          onLeftAction={() => setBannerOpen(false)}
          onRightAction={() => setFeedbackDialogOpen(true)}
        />
      )}
      <FeedbackDialog
        dialogOpen={feedbackDialogOpen}
        description={t('actions.feedbackDialogDescriptionDownloader')}
        featureKey="data-downloader"
        onClose={() => setFeedbackDialogOpen(false)}
        onSuccess={() => {
          setFeedbackDialogOpen(false);
          setFeedbackSuccessOpen(true);
        }}
        inputText={t('actions.feedbackInputDashboard')}
      />
      <ResultFeedbackDialog
        successDialogOpen={feedbackSuccessOpen}
        onClose={() => setFeedbackSuccessOpen(false)}
        icon={<SuccessIcon />}
        title={t('actions.feedbackSent')}
        description={t('actions.successFeedbackDescription')}
        rightButtonText={t('actions.gotIt')}
        onRightAction={() => setFeedbackSuccessOpen(false)}
      />
    </>
  );
};

export default FeedbackSection;
